import { makeStyles, Theme } from "@material-ui/core/styles";
import { grey300 } from "../../../../../infrastructure/theme/customColors";

const useStyles = makeStyles<Theme>((theme) => ({
  subTitle: {
    marginBottom: "21px",
  },
  checkboxContainer: {
    paddingLeft: "0px",
    paddingRight: "0px",
  },
  reasonText: {
    marginLeft: theme.spacing(2),
  },
  textArea: {
    width: "100%",
    border: `solid 1px ${grey300}`,
    borderRadius: 4,
    padding: theme.spacing(1),
    minHeight: 100,
  },
  containerButton: {
    marginTop: "38px",
  },
}));

export default useStyles;
